import { use } from "react";

import {
	ContextMenusContext,
	IContextMenusContext,
} from "@/contexts/ContextMenusContext/context";

export const useContextMenus = (): IContextMenusContext => {
	const context = use(ContextMenusContext);
	if (!context)
		throw new Error(
			"useContextMenus must be used within a ContextMenusProvider"
		);
	return context;
};
